"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSBlockMoving = exports.TSDir = exports.TSBlock = exports.TSBlockAttribute = void 0;
const KHReference_1 = require("./KH/References/KHReference");
const TSOptions_1 = require("./TSOptions");
var TSBlockAttribute;
(function (TSBlockAttribute) {
    TSBlockAttribute[TSBlockAttribute["None"] = 0] = "None";
    TSBlockAttribute[TSBlockAttribute["Blocks"] = 1] = "Blocks";
    TSBlockAttribute[TSBlockAttribute["LoseOnTouch"] = 2] = "LoseOnTouch";
    TSBlockAttribute[TSBlockAttribute["WinOnTouch"] = 3] = "WinOnTouch";
    TSBlockAttribute[TSBlockAttribute["PushableSanitize"] = 4] = "PushableSanitize";
    TSBlockAttribute[TSBlockAttribute["ChaseAndKill"] = 5] = "ChaseAndKill";
    TSBlockAttribute[TSBlockAttribute["Icy"] = 6] = "Icy";
})(TSBlockAttribute = exports.TSBlockAttribute || (exports.TSBlockAttribute = {}));
class TSBlock extends Phaser.GameObjects.Container {
    constructor(scene, type, attr = TSBlockAttribute.Blocks) {
        super(scene, 0, 0);
        scene.add.existing(this);
        this.attr = attr;
        this._block = scene.add.sprite(0, 0, 'block').setAlpha(0.6);
        this.add(this._block);
        this._selectedSprite = scene.add.sprite(0, 0, 'select');
        this.add(this._selectedSprite);
        this._text = scene.add.bitmapText(0, 0, 'font', '', 6).setOrigin(0.5).setTint(0xFFFFFF);
        this._text.setDropShadow(0, 1, 0x0, 0.3);
        this.add(this._text);
        this.showText(true);
        this.setType(type);
        TSOptions_1.global_options.colorblind.registerCallback(KHReference_1.KHReference.EVENT_VALUE_CHANGED, ({ value: value }) => {
            this.showText(value);
        });
        this.showText(TSOptions_1.global_options.colorblind.get());
        this.setSelected(false);
    }
    isDead() {
        return this._dead;
    }
    getType() {
        return this._type;
    }
    setType(type) {
        this._type = type;
        this._block.setTint(type.color);
        this._text.setText(type.char);
    }
    addToGrid(grid, x, y) {
        this._grid = grid;
        this.moveToSlot(x, y);
    }
    moveToSlot(x, y) {
        this.pos = new Phaser.Math.Vector2(x, y);
        this._grid.forceAddAt(this, this.pos.x, this.pos.y);
    }
    showText(show) {
        this._text.setVisible(show);
    }
    setSelected(selected) {
        this._selectedSprite.setVisible(selected);
    }
    animateIn(delay = 0) {
        const start = this.y - 32;
        const inPos = this.y;
        this.y = start;
        this.setVisible(false);
        this.scene.tweens.add({
            targets: this,
            y: inPos,
            delay: delay,
            onStart: () => this.setVisible(true),
            ease: 'Bounce.easeOut',
            duration: 750
        });
    }
    celebrate(delay = 0, killAfter = false) {
        this.scene.tweens.add({
            targets: this,
            angle: 360,
            ease: Phaser.Math.Easing.Back.InOut,
            duration: 1000,
            delay: delay,
            onComplete: () => {
                if (killAfter)
                    this.kill(200);
            }
        });
    }
    kill(delay = 0) {
        if (this._dead) {
            console.warn("Attempted to double kill", this);
            return 300;
        }
        this._grid.remove(this);
        this._dead = true;
        const timeline = this.scene.tweens.createTimeline();
        const start = this.y;
        const inPos = this.y - 3;
        const outPos = this.y + 64;
        timeline.add({
            targets: this,
            y: inPos,
            ease: 'Cubic.easeOut',
            duration: 50,
            delay: delay,
        });
        timeline.add({
            targets: this,
            y: start,
            ease: 'Cubic.easeIn',
            duration: 50,
        });
        timeline.add({
            targets: this,
            y: outPos,
            ease: 'Linear',
            duration: 200,
            onComplete: () => {
                this.destroy();
            }
        });
        timeline.play();
        return 200 + 50 + 50;
    }
    destroy(fromScene) {
        this._text.destroy();
        this._selectedSprite.destroy();
        this._block.destroy();
        super.destroy(fromScene);
    }
}
exports.TSBlock = TSBlock;
var TSDir;
(function (TSDir) {
    TSDir[TSDir["Up"] = 0] = "Up";
    TSDir[TSDir["Left"] = 1] = "Left";
    TSDir[TSDir["Right"] = 2] = "Right";
    TSDir[TSDir["Down"] = 3] = "Down";
})(TSDir = exports.TSDir || (exports.TSDir = {}));
class TSBlockMoving extends TSBlock {
    constructor(scene, type, path, attr = TSBlockAttribute.Blocks, swaps) {
        super(scene, type, attr);
        this.swaps = swaps;
        this.path = path;
    }
    static Looping(scene, type, attr = TSBlockAttribute.Blocks, swaps, dir, start, bounds) {
        const path = this.PathToEdge(start, dir, bounds, false);
        const remainder = this.PathToEdge(this.BoundaryPos(start, this.OppositeDir(dir), bounds), dir, this.ModifiedBounds(start, dir, bounds), false);
        remainder.pop();
        path.push(...remainder);
        return new TSBlockMoving(scene, type, path, attr, swaps);
    }
    static Bouncing(scene, type, attr = TSBlockAttribute.Blocks, swaps, dir, start, bounds) {
        const path = this.PathToEdge(start, dir, bounds, false);
        const oppDir = this.OppositeDir(dir);
        path.push(...this.PathToEdge(this.BoundaryPos(start, dir, bounds), oppDir, bounds, true));
        const remainder = this.PathToEdge(this.BoundaryPos(start, oppDir, bounds), dir, this.ModifiedBounds(start, dir, bounds), true);
        remainder.pop();
        path.push(...remainder);
        return new TSBlockMoving(scene, type, path, attr, swaps);
    }
    static BoundaryPos(start, dir, bounds) {
        if (dir == TSDir.Left)
            return [bounds[0][0], start[1]];
        if (dir == TSDir.Right)
            return [bounds[1][0], start[1]];
        if (dir == TSDir.Up)
            return [start[0], bounds[0][1]];
        if (dir == TSDir.Down)
            return [start[0], bounds[1][1]];
    }
    static ModifiedBounds(start, dir, bounds) {
        if (dir == TSDir.Left)
            return [[start[0], bounds[0][1]], [bounds[1][0], bounds[1][1]]];
        if (dir == TSDir.Right)
            return [[bounds[0][0], bounds[0][1]], [start[0], bounds[1][1]]];
        if (dir == TSDir.Up)
            return [[bounds[0][0], start[1]], [bounds[1][0], bounds[1][1]]];
        if (dir == TSDir.Down)
            return [[bounds[0][0], bounds[0][1]], [bounds[1][0], start[1]]];
    }
    static PathToEdge(start, dir, bounds, skipStart) {
        const path = [];
        let curr = start;
        const offset = this.OffsetForDir(dir);
        if (skipStart) {
            curr = [curr[0] + offset[0], curr[1] + offset[1]];
        }
        while (curr[0] >= bounds[0][0] && curr[0] <= bounds[1][0] && curr[1] >= bounds[0][1] && curr[1] <= bounds[1][1]) {
            path.push(curr);
            curr = [curr[0] + offset[0], curr[1] + offset[1]];
        }
        return path;
    }
    static OppositeDir(dir) {
        switch (dir) {
            case TSDir.Left: return TSDir.Right;
            default:
            case TSDir.Right: return TSDir.Left;
            case TSDir.Up: return TSDir.Down;
            case TSDir.Down: return TSDir.Up;
        }
    }
    static OffsetForDir(dir) {
        switch (dir) {
            case TSDir.Left:
                return [-1, 0];
            case TSDir.Right:
            default:
                return [1, 0];
            case TSDir.Up:
                return [0, -1];
            case TSDir.Down:
                return [0, 1];
        }
    }
    static ModifiedLocForBlock(block, dir) {
        return this.ModifiedLocForPos(block.pos, dir);
    }
    static ModifiedLocForPos(pos, dir) {
        return this.ModifiedLoc([pos.x, pos.y], dir);
    }
    static ModifiedLoc(pos, dir) {
        const offset = this.OffsetForDir(dir);
        return [pos[0] + offset[0], pos[1] + offset[1]];
    }
    static DirForOffset(offset) {
        if (offset[0] > 0)
            return TSDir.Right;
        if (offset[0] < 0)
            return TSDir.Left;
        if (offset[1] > 0)
            return TSDir.Down;
        if (offset[1] < 0)
            return TSDir.Up;
        return null;
    }
}
exports.TSBlockMoving = TSBlockMoving;
